import { isNormalPiece } from './components/MferHead';

/**
 * Finds horizontal matches for a given position on the board
 * @param {Array<Array<number>>} board - 2D array representing the game board
 * @param {number} row - Row index to check
 * @param {number} col - Column index to check
 * @param {number} boardSize - Size of the board (assumes square board)
 * @returns {Array} [matches, isCenterPiece] - Array of match positions and whether the piece is in center
 */
export const horizontalMatchPositions = (board, row, col, boardSize) => {
    const jewelType = board[row][col];
    let matches = [];

    let maxMatch = -1;
    let minMatch = boardSize;
    
    // Check right side from current position
    for (let i = col; i < boardSize; i++) {
        if (board[row][i] === jewelType && isNormalPiece(board[row][i])) {
            matches.push({row, col: i});
            maxMatch = i > maxMatch ? i : maxMatch;
            minMatch = i < minMatch ? i : minMatch;
        } else {
            break;
        }
    }

    // Check left side from current position
    for (let i = col - 1; i >= 0; i--) {
        if (board[row][i] === jewelType && isNormalPiece(board[row][i])) {
            matches.push({row, col: i});
            maxMatch = i > maxMatch ? i : maxMatch;
            minMatch = i < minMatch ? i : minMatch;
        } else {
            break;
        }
    }
    
    return matches.length >= 3 ? [matches, col === Math.floor((minMatch + maxMatch) / 2)] : [[], false];
};

/**
 * Finds vertical matches for a given position on the board
 * @param {Array<Array<number>>} board - 2D array representing the game board
 * @param {number} row - Row index to check
 * @param {number} col - Column index to check
 * @param {number} boardSize - Size of the board (assumes square board)
 * @returns {Array} [matches, isCenterPiece] - Array of match positions and whether the piece is in center
 */
export const verticalMatchPositions = (board, row, col, boardSize) => {
    const jewelType = board[row][col];
    let matches = [];
    let maxMatch = -1;
    let minMatch = boardSize;
    
    // Check down from current position
    for (let i = row; i < boardSize; i++) {
        if (board[i][col] === jewelType && isNormalPiece(board[i][col])) {
            matches.push({row: i, col});
            maxMatch = i > maxMatch ? i : maxMatch;
            minMatch = i < minMatch ? i : minMatch;
        } else {
            break;
        } 
    }

    // Check up from current position
    for (let i = row - 1; i >= 0; i--) {
        if (board[i][col] === jewelType && isNormalPiece(board[i][col])) {
            matches.push({row: i, col});
            maxMatch = i > maxMatch ? i : maxMatch;
            minMatch = i < minMatch ? i : minMatch;
        } else {
            break;
        }
    }
    
    return matches.length >= 3 ? [matches, row === Math.floor((minMatch + maxMatch) / 2)] : [[], false];
};